(function () {
  'use strict';
  var key = 'eb_campaign_session_v1';
  var maxAge = 30 * 24 * 60 * 60 * 1000;
  var record = null;
  var fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'campaign_id', 'ad_id'];

  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return !!(privacy && privacy.analyticsProcessingAllowed() && privacy.marketingAllowed());
    } catch (error) { return false; }
  }

  function forget() {
    record = null;
    try { sessionStorage.removeItem(key); } catch (error) {}
  }

  function clean(value) {
    return typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, '').slice(0, 200) : '';
  }

  function touch() {
    var params = new URLSearchParams(window.location.search);
    var result = {};
    fields.forEach(function (field) {
      var value = clean(params.get(field));
      if (value) result[field] = value;
    });
    if (!result.utm_source && !result.utm_campaign && !result.utm_id && !result.campaign_id && !result.ad_id) return null;
    var view = clean(params.get('view')).replace(/[^a-z0-9_-]/gi, '').slice(0, 40);
    result.path = window.location.pathname + (view ? '?view=' + view : '');
    result.at = new Date().toISOString();
    return result;
  }

  function capture() {
    if (!allowed()) { forget(); return; }
    if (!record) {
      try { record = JSON.parse(sessionStorage.getItem(key)); } catch (error) { record = null; }
    }
    if (record && (!record.first || !record.last || !Number.isFinite(record.created) || Date.now() - record.created > maxAge || record.created > Date.now())) record = null;
    var current = touch();
    if (current) {
      if (!record) record = { created: Date.now(), first: current, last: current };
      else if (fields.concat(['path']).some(function (field) { return current[field] !== record.last[field]; })) record.last = current;
    }
    if (record) {
      try { sessionStorage.setItem(key, JSON.stringify(record)); } catch (error) {}
    }
  }

  function properties() {
    capture();
    if (!allowed() || !record) return {};
    var result = {};
    fields.forEach(function (field) {
      var value = clean(record.last[field]);
      if (value) result['_eb_' + field] = value;
    });
    result._eb_landing_path = clean(record.last.path);
    result._eb_campaign_captured_at = clean(record.last.at);
    var first = clean(record.first.utm_campaign);
    if (first) result._eb_first_campaign = first;
    return result;
  }

  window.EBAttribution = { properties: properties };
  document.addEventListener('visitorConsentCollected', capture);
  window.addEventListener('pageshow', capture);
  if (window.Shopify && window.Shopify.customerPrivacy) capture();
  else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) capture();
    });
  }
}());
